import React from 'react';
import { createRoot } from 'react-dom/client';

// import './css/index.css';
// import './css/Page1.css';
// import './css/Page1Mobile.css';
// import './css/ButtonCarousel.css';
// import './css/Page2.css';
// import './css/PageOverlay.css';
// import './css/DynamicPages/PageCpp.css';
import './css/V2/Page1.css';
import './css/V2/Page1Mobile.css';
import './css/V2/Page2.css';
import './css/V2/Carousel.css';
import App from './components/App';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);